export default __webpack_public_path__ + "static/media/reactjs2.9849bd54.svg";